import React, { useEffect, useState } from "react"
import { MDBDataTable } from "mdbreact"
import {
    Row,
    Col,
    Card,
    CardBody,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    DropdownToggle,
    Button,
    Modal,
    Form,
} from "reactstrap"
import { connect } from "react-redux"
import { setBreadcrumbItems } from "../../store/actions"
import { Link } from "react-router-dom"
import Breadcrumb from "../../components/Common/Breadcrumb"
// Import images
import substrateImg from "../../assets/images/SubstrateImg.png"
import fruitingImg from "../../assets/images/fruiting1.png"
import Inoculation from "../../assets/images/inoculation.png"
import axios from "axios"
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

import "../ProcessSequence/datatables.scss"

const DatatableTables = props => {
    document.title = "Farm Master | My Urban Farms "

    const breadcrumbItems = []

    const [modal_center, setmodal_center] = useState(false)
    const [editModal, setEditModal] = useState(false)
    const [openDropdown, setOpenDropdown] = useState(null)
    const [editingItem, setEditingItem] = useState(null);
    const [rows, setRows] = useState([]);
    const [showPassword, setShowPassword] = useState(false);

    const togglePassword = () => setShowPassword(!showPassword);




    useEffect(() => {
        fetchFarms();
    }, []);

    const fetchFarms = async () => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/getAllFarms/farm/`
            );
            const res = response.data;
            if (res?.message?.success && Array.isArray(res.message.data)) {

                const mapped = res.message.data.map((item, idx) => ({
                    id: idx + 1,
                    sno: `${idx + 1}`,
                    pk_farm_key: item.pk_farm_key,
                    "Farm Name": item.farm_name || "-",
                    "Farm Address": item.farm_address || "-",
                    farm_email: item.farm_email || "-",
                    original_password: item.original_password || "-",
                }));
                setRows(mapped);
            }
        } catch (err) {
            console.error("Failed to fetch data:", err);
        }
    };

    const toggleDropdown = id => {
        setOpenDropdown(openDropdown === id ? null : id)
    }

    function tog_center() {
        if (!modal_center) {
            setEditingItem(null);
            formik.resetForm();
        }
        setmodal_center(!modal_center)
    }


    useEffect(() => {
        props.setBreadcrumbItems("Farm Master", breadcrumbItems)
    }, [])

    const adminKey = sessionStorage.getItem("pk_admin_key") || "";

    const formik = useFormik({
        initialValues: {
            farm_name: "",
            farm_address: "",
            farm_email: "",
            farm_password: "",
        },
        validationSchema: Yup.object({
            farm_name: Yup.string().required("Farm Name is required"),
            farm_address: Yup.string().required("Address is required"),
            farm_email: Yup.string().required("Email is required"),
            farm_password: Yup.string().required("Password is required"),
        }),
        onSubmit: async (values) => {
            const formData = new FormData();
            formData.append("farm_name", values.farm_name);
            formData.append("farm_address", values.farm_address);
            formData.append("farm_email", values.farm_email);
            formData.append("farm_password", values.farm_password);
            formData.append("status", 1);
            formData.append("created_by", adminKey);

            try {
                let response;

                if (editingItem) {
                    // Update
                    formData.append("pk_farm_key", editingItem.pk_farm_key);
                    response = await axios.post(
                        `${process.env.REACT_APP_API_BASE_URL}/updateFarm/farm/`,
                        formData,
                        { headers: { "Content-Type": "multipart/form-data" } }
                    );
                    toast.success("Updated successfully!", { autoClose: 3000 });
                } else {
                    // Add
                    response = await axios.post(
                        `${process.env.REACT_APP_API_BASE_URL}/addFarm/farm/`,
                        formData,
                        { headers: { "Content-Type": "multipart/form-data" } }
                    );
                    toast.success("Added successfully!", { autoClose: 3000 });
                }

                fetchFarms();
                closeModal();
            } catch (error) {
                console.error("Error saving data:", error);
                toast.error("Error saving data!", { autoClose: 3000 });
            }
        },
    });

    const deleteItem = (pk_farm_key) => {
        Swal.fire({
            title: "Are you sure?",
            text: "This Farm will be permanently deleted!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await axios.post(
                        `${process.env.REACT_APP_API_BASE_URL}/deleteFarm/farm/`,
                        { pk_farm_key }
                    );
                    Swal.fire("Deleted!", "Farm deleted successfully", "success");
                    toast.success("Deleted successfully!", { autoClose: 3000 });
                    fetchFarms();
                } catch (error) {
                    Swal.fire("Error!", "Failed to delete farm", "error");
                }
            }
        });
    };


    const closeModal = () => {
        setmodal_center(false);
        setEditModal(false);
        setEditingItem(null);
        formik.resetForm();
    };

    const handleEdit = async (pk_farm_key) => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/getFarm/farm/`,
                { pk_farm_key }
            );

            const item = response.data?.message?.data;

            if (item) {
                setEditingItem(item); // <-- Store item including pk_farm_key

                formik.setValues({
                    farm_name: item.farm_name || "",
                    farm_address: item.farm_address || "",
                    farm_email: item.farm_email || "",
                    farm_password: item.original_password || "", // show original
                });

                setEditModal(true);
            }
        } catch (err) {
            console.error("Error fetching farm:", err);
        }
    };


    const data = {
        columns: [
            { label: "S.No", field: "sno", sort: "asc", width: 50 },
            { label: "Farm Name", field: "Farm Name", sort: "asc", width: 150 },
            { label: "Farm Address", field: "Farm Address", sort: "asc", width: 200 },
            { label: "Email", field: "farm_email", sort: "asc", width: 120 },
            { label: "Password", field: "original_password", sort: "asc", width: 150 },
            { label: "Actions", field: "actions", sort: "disabled", width: 100 },
        ],
        rows: rows.map(row => (({
            ...row,
            actions: (
                <Dropdown
                    isOpen={openDropdown === row.id}
                    toggle={() => toggleDropdown(row.id)}
                >
                    <DropdownToggle
                        tag="button"
                        className="btn btn-link text-muted p-0 border-0 shadow-none"
                    >
                        <i className="mdi mdi-dots-vertical fs-5"></i>
                    </DropdownToggle>
                    <DropdownMenu end>
                        <DropdownItem
                            onClick={() => {
                                const pkKey = row.pk_farm_key;
                                handleEdit(pkKey);
                            }}
                        >
                            <i className="mdi mdi-pencil-outline me-2"></i> Edit
                        </DropdownItem>
                        <DropdownItem divider />
                        <DropdownItem className="text-danger"
                            onClick={() => {
                                const pkKey = row.pk_farm_key;
                                deleteItem(pkKey);
                            }}>
                            <i className="mdi mdi-delete-outline me-2"></i> Delete Farm
                        </DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            )
        }))),
    }


    // const rows = [
    //   {
    //     id: 1,
    //     sno: "1",
    //     "Process Name": "Substrate Preparation",
    //     Description:
    //       "Chopping, soaking, and pasteurizing straw substrate for bag filling.",
    //     "Process Image": (
    //       <img src={substrateImg} alt="Substrate Preparation" width="80" />
    //     ),
    //     Duration: "2 Days",
    //     Day: "Day 0 - Day 2",
    //   },
    //   {
    //     id: 2,
    //     sno: "2",
    //     "Process Name": "Inoculation",
    //     Description:
    //       "Mixing mushroom spawn into the cooled substrate and sealing the bags.",
    //     "Process Image": <img src={Inoculation} alt="Inoculation" width="80" />,
    //     Duration: "1 Day",
    //     Day: "Day 3",
    //   },
    //   {
    //     id: 3,
    //     sno: "3",
    //     "Process Name": "Fruiting",
    //     Description:
    //       "Transferring bags to a light and humid environment for fruiting.",
    //     "Process Image": <img src={fruitingImg} alt="Fruiting" width="80" />,
    //     Duration: "7 Days",
    //     Day: "Day 19 - Day 26",
    //   },
    // ]


    return (
        <React.Fragment>
            <div className="d-flex align-items-center justify-content-between mb-3">
                <Breadcrumb />
                <Button
                    type="button"
                    color="primary"
                    className="waves-effect waves-light"
                    onClick={tog_center}
                >
                    <i className="mdi mdi-plus me-1"></i>
                    Add New Farm
                </Button>
            </div>

            <Row>
                <Col className="col-12">
                    <Card>
                        <CardBody>
                            <MDBDataTable
                                responsive
                                striped
                                bordered
                                data={data}
                                noBottomColumns
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            <Modal isOpen={modal_center} toggle={tog_center} centered={true}>
                <div className="modal-header">
                    <h5 className="modal-title mt-0">Add New Farm</h5>
                    <button
                        type="button"
                        onClick={() => setmodal_center(false)}
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div className="modal-body">
                    <Row>
                        <Col lg={12}>
                            <Form onSubmit={formik.handleSubmit}>

                                <div className="mb-3">
                                    <label htmlFor="farm-name" className="form-label">
                                        Farm Name <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        id="farm-name"
                                        name="farm_name"
                                        placeholder="Enter farm name"
                                        value={formik.values.farm_name}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.touched.farm_name && formik.errors.farm_name ? (
                                        <div className="text-danger mt-1">{formik.errors.farm_name}</div>
                                    ) : null}
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="farm-address" className="form-label">
                                        Farm Address <span className="text-danger">*</span>
                                    </label>
                                    <textarea
                                        className="form-control"
                                        id="farm-address"
                                        name="farm_address"
                                        rows="3"
                                        placeholder="Enter farm address"
                                        value={formik.values.farm_address}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    ></textarea>
                                    {formik.touched.farm_address && formik.errors.farm_address ? (
                                        <div className="text-danger mt-1">{formik.errors.farm_address}</div>
                                    ) : null}
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="farm-email" className="form-label">
                                        Email Address<span className="text-danger">*</span>
                                    </label>
                                    <input
                                        className="form-control"
                                        type="email"
                                        id="farm-email"
                                        name="farm_email"
                                        placeholder="Enter email"
                                        value={formik.values.farm_email}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.touched.farm_email && formik.errors.farm_email ? (
                                        <div className="text-danger mt-1">{formik.errors.farm_email}</div>
                                    ) : null}
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="farm-password" className="form-label">
                                        Password <span className="text-danger">*</span>
                                    </label>

                                    <div className="input-group">
                                        <input
                                            className="form-control"
                                            type={showPassword ? "text" : "password"}
                                            id="farm-password"
                                            name="farm_password"
                                            placeholder="Enter password"
                                            value={formik.values.farm_password}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />

                                        <span className="input-group-text" style={{ cursor: "pointer" }} onClick={togglePassword}>
                                            <i className={showPassword ? "mdi mdi-eye-off" : "mdi mdi-eye"}></i>
                                        </span>
                                    </div>

                                    {formik.touched.farm_password && formik.errors.farm_password ? (
                                        <div className="text-danger mt-1">{formik.errors.farm_password}</div>
                                    ) : null}
                                </div>


                                <div className="mt-4 text-end">

                                    <button type="button" className="btn btn-primary w-md" onClick={closeModal} style={{ marginRight: "2px" }}>
                                        Cancel
                                    </button>

                                    <button type="submit" className="btn btn-primary w-md">
                                        Submit
                                    </button>
                                </div>
                            </Form>
                        </Col>
                    </Row>
                </div>
            </Modal>

            <Modal isOpen={editModal} toggle={() => setEditModal(!editModal)} centered>
                <div className="modal-header">
                    <h5 className="modal-title mt-0">Edit Farm</h5>
                    <button
                        type="button"
                        onClick={() => { setEditModal(false); setEditingItem(null); formik.resetForm(); }}
                        className="close"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    <Form onSubmit={formik.handleSubmit}>
                        <div className="mb-3">
                            <label className="form-label">Farm Name <span className="text-danger">*</span></label>
                            <input
                                className="form-control"
                                type="text"
                                name="farm-name"
                                value={formik.values.farm_name}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            {formik.touched.farm_name && formik.errors.farm_name ? (
                                <div className="text-danger mt-1">{formik.errors.farm_name}</div>
                            ) : null}
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Farm Address <span className="text-danger">*</span></label>
                            <textarea
                                className="form-control"
                                rows="3"
                                name="farm_address"
                                value={formik.values.farm_address}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            ></textarea>
                            {formik.touched.farm_address && formik.errors.farm_address ? (
                                <div className="text-danger mt-1">{formik.errors.farm_address}</div>
                            ) : null}
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Email Address <span className="text-danger">*</span></label>
                            <input
                                className="form-control"
                                type="email"
                                name="farm_email"
                                value={formik.values.farm_email}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            {formik.touched.farm_email && formik.errors.farm_email ? (
                                <div className="text-danger mt-1">{formik.errors.farm_email}</div>
                            ) : null}
                        </div>

                        <div className="mb-3">
                            <label htmlFor="farm-password" className="form-label">
                                Password <span className="text-danger">*</span>
                            </label>
                            <input
                                className="form-control"
                                type="text"
                                id="farm-password"
                                name="farm_password"
                                placeholder="Enter password"
                                value={formik.values.farm_password}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            {formik.touched.farm_password && formik.errors.farm_password ? (
                                <div className="text-danger mt-1">{formik.errors.farm_password}</div>
                            ) : null}
                        </div>



                        <div className="mt-4 text-end">
                            <button type="button" className="btn btn-primary w-md" onClick={closeModal} style={{ marginRight: "2px" }}>
                                Cancel
                            </button>
                            <Button type="submit" className="btn  w-md" color="primary">
                                Save Changes
                            </Button>
                        </div>
                    </Form>
                </div>
            </Modal>
        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(DatatableTables)
